import script from "./ProjectSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectSettings.vue?vue&type=style&index=0&id=802a6fde&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-802a6fde"]])

export default __exports__